module.exports = __webpack_public_path__ + "img/reddit_graph.a7569191.png";